'use client'

import { forwardRef } from 'react'
import { twMerge } from 'tailwind-merge'

import { cn } from '@src/utils/tailwind'

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  isDarkMode?: boolean
}

export const Checkbox = forwardRef<HTMLInputElement, InputProps>(
  ({ className, id, children, isDarkMode, ...props }, ref) => {
    return (
      <label className={twMerge('inline-flex cursor-pointer items-start', className)} htmlFor={id}>
        <div
          className={cn(
            'flex h-10 min-w-[40px] items-center justify-center rounded-full',
            isDarkMode ? 'hover:bg-white/10' : 'hover:bg-bodi-gray-pearl'
          )}
        >
          <input
            type="checkbox"
            className={cn(
              `
            size-5 cursor-pointer rounded
            border-2 border-bodi-gray-butters
            text-bodi-accent-deep-500
            ring-0

            ring-transparent outline outline-0 outline-offset-2
            outline-transparent checked:border-bodi-accent-deep-500

            checked:bg-bodi-input-selected
            checked:hover:border-bodi-accent-deep-500
            checked:hover:bg-bodi-input-selected
            focus:ring-0

            focus:ring-transparent
            checked:focus:border-bodi-accent-deep-500

            checked:focus:bg-bodi-input-selected
            focus-visible:outline-2

            focus-visible:outline-bodi-black-text
            `,
              isDarkMode ? 'bg-white/5' : 'bg-bodi-white',
              {
                'bg-bodi-gray-light': props.disabled && !isDarkMode,
                'bg-white/10': props.disabled && isDarkMode,
              }
            )}
            ref={ref}
            {...props}
            id={id}
          />
        </div>
        <div
          className={cn('z-10 pl-3 text-body-sm', { 'text-bodi-gray-disabled': props.disabled })}
        >
          {children}
        </div>
      </label>
    )
  }
)

Checkbox.displayName = 'Checkbox'
